import { IComponentController, IComponentOptions } from 'angular';
import { StateParams } from 'angular-ui-router';
import { UserService } from '../../../../tn.user/service.tn.user';

export class OAuthPostLogoutRedirectURIComponentController
implements IComponentController
{
    static $inject = ['$stateParams', 'tn.user.service'];
    constructor($stateParams: StateParams, userService: UserService) {
        // handle in constructor, we don't need to wait on dom to render anything.
        // we want this to complete as quick as possible and redirect to the
        // correct page before doing too much work.
        try {
            userService.handleOAuthSignoutRedirect($stateParams);
        } catch (error) {
            console.error('OAuth Signout Redirect Error', error, $stateParams);
        }
    }
}

export const OAuthPostLogoutRedirectUriComponentOptions: IComponentOptions = {
    controller: OAuthPostLogoutRedirectURIComponentController,
};
